// extracted by mini-css-extract-plugin
module.exports = {"icon":"YA2IH"};